import React from 'react';
import { Spinner } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

const LoadingScreen: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Spinner appearance="primary" label={t('loadingscreen_text')} />
  );
};

export default LoadingScreen;
